const All_products = [
    {
        id: 1,
        title: "CASSIDA",
        subtitleOptional: "India's first customised coin counter and sorting machine import scroma venture",
        subtitle: "Heavy coin counter and sorting machine",
        image: "/assets/images/products/first-iamge_heavy_coincounter_and_sortnng_maching.jpeg",
        category: "one",
        specs: [
            <>
                <b>Sorting Speed:</b> Approx. 500 coins / minute
            </>,
            <>
                <b>Applicable Coins:</b> Ø 16~28mm,Thickness≤3mm
            </>,
            <>
                <b>Coin Tray Capacity:</b> Approx. 1,000 coins
            </>,
            <>
                <b>Number of Hopper:</b> 9 hoppers
            </>,
            <>
                <b>Hopper Capacity:</b> Approx. 600 coins
            </>,
            <>
                <b>Setting Range of Batch Sorting:</b> 1~9,999 coins
            </>,
            <>
                <b>Receipt Printer:</b> 58mm thermal printer
            </>,
            <>
                <b>Product Dimension:</b> 662mm(L)*365mm(W)*330mm(H)
            </>,
            <>
                <b>N.W:</b>Approx. 30KG
            </>,
            <>
                <b>Power:</b>100~240VAC 50/60Hz
            </>,
            <>
                <b>Standby Power Consumption:</b>5W
            </>,
            <>
                <b>Working Power:</b>70W
            </>,
        ],
        description: "",
        features: [
            {
                title: "Fast & Accurate Counting",
                content:
                    "The C300 counts and sorts U.S. coins (pennies, nickels, dimes, quarters, and dollar coins) at a remarkable speed of up to 300 mcoins per minute.",
            },
            {
                title: "Automatic Sorting & Wrapping",
                content:
                    "This machine automatically sorts coins into dedicated bins by denomination or fills coin tubes for easy wrapping. The One-Touch batch mode automatically stops when tubes or bins are full, ensuring perfect coin rolls every time.",
            },
            {
                title: "Innovative QuickLoad™ Technology",
                content:
                    "Say goodbye to frustrating coin wrapping. The C300 features QuickLoad™ coin tubes, which allow you to easily slide coin wrappers in and out of the base of the tube, simplifying the process and saving you valuable time.",
            },
            {
                title: "User-Friendly Interface",
                content:
                    "The large, easy-to-read LCD screen provides a clear breakdown of your count, displaying the number of coins, the total dollar value, and the value for each denomination.",
            },
            {
                title: "Multiple Modes",
                content:
                    "The C300 offers Count, Add, and Batch modes to suit all your needs.",
            },
            {
                title: "Printing Capabilities",
                content:
                    "For enhanced record-keeping and effortless bank deposits, the C300 is compatible with the Cassida Thermal Printer (sold separately) to generate detailed reports of your daily count.",
            },
            {
                title: "Compact & Portable Design",
                content:
                    "Its quiet operation and compact size make the C300 a perfect addition to any desk or workspace. It also includes a built-in handle for easy transport.",
            },
        ],
    },

    {
        id: 2,
        title: "CASSIDA ARTEMIS",
        subtitle: "2-POCKET MIX VALUE COUNTER AND SORTER",
        image: "/assets/images/products/second-image_1+1pocket_sorting_machine.jpeg",
        category: "one",
        specs: [
            <>
                <b>Currency Range:</b> up to 15 currencies
            </>,
            <>
                <b>Counting Speed, bills/min:</b> 800/1000
            </>,
            <>
                <b>Hopper Capacity, bills:</b> 500 - 1000
            </>,
            <>
                <b>Stacker capacity, bills:</b> 200
            </>,
            <>
                <b>Reject Capacity, bills:</b> 100
            </>,
            <>
                <b>Operating Modes:</b> MIX, SORT, FACE, ORIENT, VALUE BATCH, SORT,COUNT
            </>,
            <>
                <b>Reports on the display:</b> Auto currency recognition & All currency mix mode
            </>,
            <>
                <b>Display:</b> LCD Touch Screen
            </>,
            <>
                <b>Interface:</b> Android Port; LAN Port; RS -232 Port; USB 2.0 Port
            </>,
            <>
                <b>Feeding System:</b> Roller Friction System
            </>,
            <>
                <b>Power Supply:</b> 100 - 240v 50/60Hz
            </>,
            <>
                <b>Unit Dimension (W*D*H), mm:</b> 280 * 260 * 320
            </>,
            <>
                <b>Weight:</b> 7.5Kg
            </>,
        ],
        description: "",
        features: [
            {
                title: "PRODUCT FEATURES:",
                content: [
                    <ul>
                        <li>Mixed-value and multi- currency counting simultaneously.</li>
                        <li>Sorting: denomination, issue, face, orientation.</li>
                        <li>Automatic Currency Recognition.</li>
                        <li>Banknote Size Detection.</li>
                        <li>Advanced Dual CIS Counterfeit Detection</li>
                    </ul>

                ]
            },
            {
                title: "ADVANTAGES",
                content: [
                    <ul>
                        <li>Fast and guaranteed accurate counting.</li>
                        <li>Auto matically sorts mixed bills as sort mode stops and alerts each time there’s a change in denomination.</li>
                        <li>Fast and easy update of database for newly issued bills. new currencies and or other necessary updates.</li>
                    </ul>

                ]
            },


        ],
    },
    {
        id: 3,
        title: "CASSIDA XPECTO",
        subtitle: "SINGLE POCKET MIX VALUE COUNTER",
        image: "/assets/images/products/3image_2csi_missvalue_counting_machine.jpeg",
        category: "five",
        specs: [
            <>
                <b>Currency Range:</b> Optional
            </>,
            <>
                <b>Currency Number:</b> Up to 20
            </>,
            <>
                <b>Counting Speed, bills/min:</b> 600-800-1000 (Mixed Mode) 1200 (Count Mode)
            </>,
            <>
                <b>Hopper/ Stacker bills:</b> 400-500/200
            </>,
            <>
                <b>Operating Modes:</b> Mix, Sort, Count, Face, Orientation
            </>,
            <>
                <b>Batch Notes:</b> 1-100
            </>,
            <>
                <b>Dimensions (WxDxH):</b> 11 x 11.4 x 10.4
            </>,
            <>
                <b>Counterfeit Detection:</b> Dual CIS, UV, MG, IR, MT, 3D
            </>,
            <>
                <b>Count Error Detections:</b> DBL, HLF, Chain, SD
            </>,
            <>
                <b>Reports on the Display:</b> Counting mode, Selected Denom, Total number of bills, Total value of All counted bills, Total number and value of each denomination, Error code
            </>,
            <>
                <b>Bills Size:</b> 110*60, 185*90mm
            </>,
            <>
                <b>Printer:</b> Option
            </>,
            <>
                <b>Display: </b> 3.3 LCD touchscreen
            </>,
            <>
                <b>Feeding System:</b> Roller Friction System
            </>,
            <>
                <b>Power Supply</b> AC 100-240V /50-60Hz
            </>,
            <>
                <b>Power Consumption:</b> 40W
            </>,
            <>
                <b>Connection Port:</b> USB, RS232, LAN
            </>,
            <>
                <b>Unit Dimension (W*D*H), mm:</b> 280*240*280
            </>,
            <>
                <b>Net Weight:</b> 5.6 Kg
            </>,
            <>
                <b>Gross Weight :</b> 7 Kg
            </>,
        ],
        description: "",
        features: [
            {
                title: "MULTI-CURRENCY VALUE COUNTER:",
                content: [
                    <ul>
                        <li>Capable of counting up to 20 currencies.</li>
                        <li>Mixed Currencies counting is possible in case there are different currencies in one stack.</li>
                        <li>Advanced Technology allows quick bill counting and counterfeit detection simultaneously</li>
                        <li>Sorting of banknotes by year of release is possible.</li>
                        <li>Sorting of banknotes by orientation is possible in which orientation is determined by first counted banknote.</li>
                    </ul>

                ]
            },
            {
                title: "CONSTAN COUNT AND DETECTION QUALITY:",
                content: [
                    <ul>
                        <li>Smooth counting of both worn and new bills.</li>
                        <li>Constructed of durable materials.</li>
                        <li>Easy software updates on newly issued banknotes or changes via usb.</li>
                        <li>Engineered for easy, carefree maintenance.</li>
                        <li>External display included in the box.</li>
                    </ul>

                ]
            },


        ],
    },
    {
        id: 4,
        title: "",
        subtitle: "All type of mix currency",
        image: "/assets/images/products/4th_alltypeofmixcurrency.jpeg",
        category: "ten",
        specs: [
            <>
                <b>Model:</b>Mix Value Counter
            </>,

            <>
                <b>Applicable Currency:</b>INR (Indian Rupees)
            </>,
            <>
                <b>Counting Speed:</b>≥ 1000 pcs/min
            </>,
            <>
                <b>Hopper Capacity</b>300 pcs
            </>,
            <>
                <b>Stacker Capacity:</b>300 pcs
            </>,

            <>
                <b>Net Weight:</b>6.4 kg
            </>,
            <>
                <b>Dimensions (L × W × H):</b>320 × 250 × 180 mm
            </>,
            <>
                <b>Note Size Range:</b>Width: 50–110 mm, Length: 90–190 mm
            </>,
            <>
                <b>Power Supply:</b>230 V AC ±10%, 50 Hz
            </>,


        ],
        description: "Sturdy design combined with modern electronic technology ensures accurate counting with value detection and counterfeit note identification. The simple user interface makes it easy to operate.",
        features: [
            {
                title: "Colour TFT Display with 21-Key Keyboard",

            },
            {

                title: "External LCD Display shows:",
                content: [
                    <ul>
                        <li>Counted Pieces</li>
                        <li>Amount (Value)</li>
                        <li>Counterfeit Parameters</li>
                    </ul>
                ]
            },
            {
                title: "Displays denomination-wise counted pieces and total value",

            },
            {
                title: "Digital Pulse Processing:",

            },
            {
                title: "Denomination Sort Function",

            },
            {
                title: "Automatic Start, Stop, and Clear operations",

            },
            {
                title: "Detects faulty/counterfeit notes using",
                content: [
                    <ul>
                        <li>UV (Ultraviolet)</li>
                        <li>MG (Magnetic)</li>
                        <li>IR (Infrared)</li>
                        <li>3D Detection</li>
                        <li>Colour Detection</li>
                    </ul>
                ]
            },
            {
                title: "Modes of Operation:",
                content: [
                    <ul>
                        <li>MIX Mode</li>
                        <li>SORT Mode</li>
                        <li>DETECT Mode</li>
                        <li>COUNT Mode</li>
                        <li>BATCH Mode</li>
                        <li>ADD Mode</li>
                    </ul>
                ]
            },
            {
                title: "Voice and Self-Examination functions",
            },
            {
                title: "Software Upgradable via RS-232 port",
            },
            {
                title: "Specially designed and developed for Indian Currency",
            },

        ],
    },
    {
        id: 5,
        title: "ALFA PC pro",
        subtitle: "GOLD TESTING MACHINE",
        image: "/assets/images/products/5image_goldtestingmachine.jpeg",
        category: "twenty",
        specs: [
            <>
                <b>X-ray Excitation:</b>50w(KV & 1mA)micro-focused wanode tube.
            </>,
            <>
                <b>Detector:</b>High Resolution Proportional Counter Detector.
            </>,
            <>
                <b>Focal Depth:</b>Single xed focal depth with laser and auto focus.
            </>,
            <>
                <b>Detecting Elements:</b>Gold,Silver, Copper, Nickel, Zinc & Platinum.
            </>,
            <>
                <b>Accuracy:</b>+ or -0.3%
            </>,
            <>
                <b>Working Environment:</b>50 F(15 C)to104 F(30 С).
            </>,
            <>
                <b>Weight:</b>22Kg
            </>,
            <>
                <b>Analysis Layers & Elements:</b>5 layer(4 layer + base) and 3 elements in each layer
                composition analysis of up to 7 elements simultaneously.
            </>,
            <>
                <b>Power Supply:</b>150W,100-240volts,frequency range 50Hz to 60Hz.
            </>,


        ],
        description: "High Performance X-Ray Fluorescence Measuring Instrument for fast and nondestructive Material Analysis and Coating Thickness Measurement.",
        features: [
            {
                title: "Analysis Report:",
                content: [
                    <ul>
                        <li>Output, as Generated Excel.PDF,JPG & PNG.</li>
                    </ul>
                ]
            },
            {
                title: "Filters/Collimators:",
                content: [
                    <ul>
                        <li>4 primary Iters/0.50mm collimator(optional dual).</li>
                    </ul>
                ]
            },
            {
                title: "Digital Pulse Processing:",
                content: [
                    <ul>
                        <li>4096 CH digital multi-channel analyser with exible
                            shaping time.Automatic signal processing including
                            dead time correction and escape peak correction.
                        </li>
                    </ul>
                ]
            },
            {
                title: "Processor:",
                content: [
                    <ul>
                        <li>Intel, core i5 3470(3.2GHz),8GB DDB3 Memory, Microsoft Windows 7,32bit equivalent.</li>
                    </ul>
                ]
            },
            {
                title: "Camera Optics:",
                content: [
                    <ul>
                        <li>High Resolution,1.2million pixel CCD Camera.</li>
                    </ul>
                ]
            },
            {
                title: "Dimensions:",
                content: [
                    <ul>
                        <li>460mm X 380mm X 460mm</li>
                    </ul>
                ]
            },

        ],
    },

];

export default All_products;
